import { render } from "./DevicePage.vue?vue&type=template&id=08971a10"
import script from "./DevicePage.vue?vue&type=script&lang=js"
export * from "./DevicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__